/* @flow */
import Avatar from 'entities/Avatar';
import Entity from 'lib/Entity';

export default class GroupClusterItem extends Entity {

  defaults() {
    return {
      group_avatar: null,
    };
  }

  parse(response: Object) {
    if (response['group_avatar']) {
      response['group_avatar'] = Avatar.fromJSON(response['group_avatar']);
    }
    return response;
  }

  // $FlowFixMe
  get avatarSvgUrl(): ?string {
    const avatar = this.get('group_avatar');
    return avatar ? avatar.get('svg_url') : null;
  }

}



// WEBPACK FOOTER //
// ./src/entities/GroupClusterItem.js